module.exports = __webpack_public_path__ + "img/vob.ba412a55.png";